import React, { useState, useEffect } from "react";
import {
  RevertIcon,
  Eye,
  EyeOff,
} from "../../../components/admin/DashboardIcons.jsx";
import { Spinner } from "@heroui/react";
import {
  Button,
  Input,
  Checkbox,
  Select,
  SelectItem,
  Autocomplete,
  AutocompleteItem,
  Alert,
  Textarea,
} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/react";
import PublishPreviewModal from "../../admin/Results/PublishPreviewModal.jsx";

const resolveBasePath = () =>
  window.location.pathname.startsWith("/operator") ? "/operator" : "/admin";

// Convert date from dd-mm-yyyy to yyyy-mm-dd format for HTML date input
const convertDateToInputFormat = (dateString, today) => {
  if (!dateString) return today;

  // Check if already in yyyy-mm-dd format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }

  // Check if in dd-mm-yyyy format and convert
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  }

  // If format is unknown, return today
  return today;
};

const ResultForm = ({
  formData,
  setFormData,
  onSubmit,
  onCancel,
  marketData,
  setMarketData,
  getAdminDashboardResultsList,
  disabledRows,
  setDisabledRows,
  inputValues,
  setInputValues,
  selectedRows,
  setSelectedRows,
  resultDetails,
  setResultDetails,
  selectedMarketId,
  setSelectedMarketId,
  selectedMatchName,
  setSelectedMatchName,
}) => {
  const [matches, setMatches] = useState([]);
  const [filteredMatches, setFilteredMatches] = useState([]);
  const [matchSearchValue, setMatchSearchValue] = useState("");

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onOpenChange: onPreviewOpenChange,
  } = useDisclosure();
  const [previewContext, setPreviewContext] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [openResultLength, setOpenResultLength] = useState(0);
  const [closeResultLength, setCloseResultLength] = useState(0);
  const [singleOpenDigit, setSingleOpenDigit] = useState("-");
  const [singleCloseDigit, setSingleCloseDigit] = useState("-");
  const [jodiCloseDigit, setJodiCloseDigit] = useState("--");
  const [openPattiType, setOpenPattiType] = useState("");
  const [closePattiType, setClosePattiType] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordValue, setPasswordValue] = useState("");
  const [isPublishing, setIsPublishing] = useState(false);
  const [publishPayload, setPublishPayload] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const [rollbackData, setRollbackData] = useState({
    gameIndex: null,
    mmid: null,
    status: null,
    result: null,
  });

  const [pendingRollback, setPendingRollback] = useState(null);

  const [rollbackReason, setRollbackReason] = useState("");
  const [otpValue, setOtpValue] = useState("");

  const [otpModalOpen, setOtpModalOpen] = useState(false);

  const typeLabels = {
    1: "single",
    2: "singlePatti",
    3: "doublePatti",
    4: "triplePatti",
    5: "jodi",
  };
  const allowedTriplePatti = [
    "0",
    "111",
    "222",
    "333",
    "444",
    "555",
    "666",
    "777",
    "888",
    "999",
  ];

  const allowed = [
    "0",
    "111",
    "222",
    "333",
    "444",
    "555",
    "666",
    "777",
    "888",
    "999",
  ];

  const [selectAll, setSelectAll] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(
    convertDateToInputFormat(formData?.matchDate, today)
  );

  const handleRowCheckboxChange = (rowKey, isChecked) => {
    if (selectedMatchName === "") {
      setModalMessage("Please choose Market / Match");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }
    setSelectedRows((prev) => ({ ...prev, [rowKey]: isChecked }));
  };

  const handleSubmit = () => {
    const payload = [];
    const matchId = Number(selectedMatchName);

    if (inputValues.single.open !== inputValues.single.openres) {
      setModalMessage("Please confirm your open result");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }

    if (selectedRows.row22 === true) {
      if (
        (selectedRows.row2 === false && selectedRows.row22 === true) ||
        (selectedRows.row2 === true && selectedRows.row22 === false)
      ) {
        setModalMessage("Please confirm your close result");
        setModalType("alert");
        setModalCallback(null);
        onMessageOpen();
        return;
      }
      if (inputValues.single.close !== inputValues.single.closeres) {
        setModalMessage("Both close results must be same");
        setModalType("alert");
        setModalCallback(null);
        onMessageOpen();
        return;
      }
    }

    const open = inputValues.single.open?.trim();
    const close = inputValues.single.close?.trim();

    const hasOpen = open && /^\d{3}$/.test(open);
    const hasClose = close && /^\d{3}$/.test(close);

    if (selectedMarketId === "" || selectedMatchName === "") {
      setModalMessage("Please choose Market / Match");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }

    if (!hasOpen && !hasClose) {
      setModalMessage("Please enter at least Open result");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }

    if (hasOpen && !/^\d{3}$/.test(open)) {
      setModalMessage("Open result must be 3 digits.");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }

    // if (hasClose && !/^\d{3}$/.test(close)) {
    //   setModalMessage("Close result must be 3 digits.");
    //   setModalType("alert");
    //   setModalCallback(null);
    //   onMessageOpen();
    //   return;
    // }
    if (selectedRows.row22) {
      // Must be exactly 3 digits
      if (!/^\d{3}$/.test(inputValues.single.close)) {
        setModalMessage("Close result must be 3 digits.");
        setModalType("alert");
        setModalCallback(null);
        onMessageOpen();
        return;
      }
    }

    const pattiMap = {
      singlePatti: 2,
      doublePatti: 3,
      triplePatti: 4,
    };

    payload.push({
      type_id: 1,
      mmid: inputValues.single.mmid,
      open_result: hasOpen ? singleOpenDigit : "",
      close_result: hasClose ? singleCloseDigit : "",
    });

    Object.entries(pattiMap).forEach(([pattiKey, typeId]) => {
      const mmid = inputValues[pattiKey]?.mmid;
      if (!mmid) return;

      payload.push({
        type_id: typeId,
        mmid,
        open_result: hasOpen ? open : "",
        close_result: hasClose ? close : "",
      });
    });

    if (hasOpen && hasClose) {
      const openStr = String(singleOpenDigit).padStart(1, "0");
      const closeStr = String(singleCloseDigit).padStart(1, "0");

      payload.push({
        type_id: 5,
        mmid: inputValues.jodi.mmid,
        open_result: openStr + closeStr,
        close_result: openStr + closeStr,
      });
    }

    if (payload.length === 0) {
      setModalMessage("Nothing to publish.");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }

    setPreviewContext({
      matchId,
      openDigit: hasOpen ? getLastDigitSum(open) : null,
      closeDigit: hasClose ? getLastDigitSum(close) : null,
    });

    setModalMessage("Are you sure you want to publish these results?");
    setModalType("confirm");
    setModalCallback(() => () => {
      // setPublishPayload(payload);
      // setIsPasswordModalOpen(true);
      const result = [];
      payload.forEach(({ open_result, close_result, ...base }) => {
        if (open_result !== undefined && open_result !== "") {
          result.push({ ...base, open_result });
        }
        if (close_result !== undefined && close_result !== "") {
          result.push({ ...base, close_result });
        }
      });

      const combinedData = Object.values(result);

      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

      const requestBody = {
        user_id: localStorage.getItem("uid"),
        result: combinedData,
        payload: payload,
      };

      const requestOptions = {
        method: "POST",
        headers,
        body: JSON.stringify(requestBody),
      };

      fetch(
        process.env.REACT_APP_API_HOST_OP + "/resultpublish",
        requestOptions
      )
        .then(() => {
          setModalMessage("Result published successfully!");
          setModalType("alert");
          setModalCallback(() => () => {
            onCancel(false);
            getAdminDashboardResultsList();
          });
          setModalAutoCloseMs(1000);
          onMessageOpen();
        })
        .catch((err) => {
          console.error("Publish error:", err);
          setModalMessage("Failed to publish results.");
          setModalType("alert");
          setModalCallback(null);
          onMessageOpen();
        });
    });

    onPreviewOpen();
    return;
  };

  const handleConfirmPublish = async (onClose) => {
    if (!passwordValue) {
      setModalMessage("Password required");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
      return;
    }

    setIsPublishing(true);

    try {
      // Prepare result payload same as before
      const result = [];
      publishPayload.forEach(({ open_result, close_result, ...base }) => {
        if (open_result !== undefined && open_result !== "") {
          result.push({ ...base, open_result });
        }
        if (close_result !== undefined && close_result !== "") {
          result.push({ ...base, close_result });
        }
      });

      const combinedData = Object.values(result);

      const uid = localStorage.getItem("uid");

      const requestBody = {
        user_id: uid,
        result: combinedData,
        payload: publishPayload,
        password: passwordValue, // 👈 send password along
      };

      const response = await fetch(
        process.env.REACT_APP_API_HOST_OP + "/resultpublish",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("jwt"),
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (data.success) {
        setIsPasswordModalOpen(false);
        setPasswordValue("");
        setModalMessage("Result published successfully!");
        setModalType("alert");
        setModalCallback(() => () => {
          onCancel(false);
          getAdminDashboardResultsList();
        });
        setModalAutoCloseMs(1000);
        onMessageOpen();
      } else {
        setModalMessage(data.message || "Invalid password or publish failed.");
        setModalType("alert");
        setModalCallback(null);
        onMessageOpen();
      }
    } catch (err) {
      console.error("Publish error:", err);
      setModalMessage("Something went wrong during publish.");
      setModalType("alert");
      setModalCallback(null);
      onMessageOpen();
    } finally {
      setIsPublishing(false);
      if (onClose) onClose();
    }
  };

  const handleMarketChange = (e) => {
    setInputValues({
      single: { open: "", openres: "", close: "", closeres: "", mmid: -1 },
      singlePatti: { open: "", close: "", mmid: -1 },
      doublePatti: { open: "", close: "", mmid: -1 },
      triplePatti: { open: "", close: "", mmid: -1 },
      jodi: { open: "", close: "", mmid: -1 },
    });
    setSelectedRows({
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      row5: false,
      row11: false,
      row22: false,
    });
    setDisabledRows({
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      row5: false,
      row11: false,
      row22: false,
    });
    setResultDetails([]);

    const marketId = e.target.value;
    console.log("Selected Market ID:", marketId);
    setSelectedMarketId(marketId);
    setSelectedMatchName("");
    setFormData({ mode: "Add", matchDate: "" });
    console.log("Market Data in handleMarketChange:", marketData);
    const selected = marketData.find((m) => m?.id?.toString() === marketId);
    const matchesList = selected ? selected.matches : [];
    setMatches(matchesList);
    setFilteredMatches(matchesList);
    setMatchSearchValue("");
  };

  const handleRollBack = (
    type_id,
    mmid,
    open_close,
    resultDigit,
    reason,
    digit
  ) => {
    if (open_close === 1) {
      const payload = [];
      const payloadForResult = [];

      const open = inputValues.single.open?.trim();
      const close = inputValues.single.close?.trim();

      const hasOpen = open && /^\d{3}$/.test(open);
      const hasClose = close && /^\d{3}$/.test(close);

      const pattiMap = {
        singlePatti: 2,
        doublePatti: 3,
        triplePatti: 4,
      };

      // let singleOpenDigit = getLastDigitSum(digit);
      let singleCloseDigit = getLastDigitSum(digit);

      payload.push({
        type_id: 1,
        mmid: inputValues.single.mmid,
        open_result: hasOpen ? singleOpenDigit : "",
        // close_result: hasClose ? singleCloseDigit : "",
      });
      payloadForResult.push({
        type_id: 1,
        mmid: inputValues.single.mmid,
        // open_result: hasOpen ? singleOpenDigit : "",
        close_result: hasClose ? singleCloseDigit : "",
      });

      // Always add type_id: 2-4 for Patti types (with available open/close)
      Object.entries(pattiMap).forEach(([pattiKey, typeId]) => {
        const mmid = inputValues[pattiKey]?.mmid;
        if (!mmid) return;

        payload.push({
          type_id: typeId,
          mmid,
          open_result: hasOpen ? open : "",
          // close_result: hasClose ? close : "",
        });
        payloadForResult.push({
          type_id: typeId,
          mmid,
          // open_result: hasOpen ? open : "",
          close_result: hasClose ? close : "",
        });
      });

      // Jodi (only when both open and close are present)
      if (hasOpen && hasClose) {
        // console.log("In Jodi Rollback");
        const open = String(singleOpenDigit).padStart(1, "0");
        const close = String(singleCloseDigit).padStart(1, "0");

        payload.push({
          type_id: 5,
          // match_id: matchId,
          mmid: inputValues.jodi.mmid,
          open_result: "",
          // close_result: open + close,
        });
        payloadForResult.push({
          type_id: 5,
          // match_id: matchId,
          mmid: inputValues.jodi.mmid,
          open_result: open + close,
          close_result: open + close,
        });

        // payload.push({
        //   type_id: 5,
        //   match_id: matchId,
        //   mmid: inputValues.jodi.mmid,
        //   open_result: "",
        //   close_result: singleOpenDigit + "" + singleCloseDigit,
        // });
      }

      if (payload.length === 0) {
        setModalMessage("Nothing to publish.");
        setModalType("alert");
        setModalCallback(null);
        onMessageOpen();
        return;
      }

      // setModalMessage("Are you sure you want to rollback this  result?");
      // setModalType("confirm");
      // setModalCallback(() => () => {
      const result = [];

      payloadForResult.forEach(
        ({ open_result, close_result, type_id, ...base }) => {
          if (close_result !== undefined && close_result !== "") {
            result.push({ ...base, type_id, close_result });
            if (
              type_id === 5 &&
              open_result !== undefined &&
              open_result !== ""
            ) {
              result.push({ ...base, type_id, open_result });
            }
          }
        }
      );

      const combinedData = Object.values(result);

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

      const requestBody = {
        user_id: localStorage.getItem("uid"),
        result: combinedData,
        payload: payload,
      };

      const requestOptions = {
        method: "POST",
        headers,
        body: JSON.stringify(requestBody),
      };

      fetch(
        process.env.REACT_APP_API_HOST_OP + "/rollbackrequest",
        requestOptions
      )
        .then(() => {
          setModalMessage("Results rollbacked successfully!!!");
          setModalType("alert");
          setModalCallback(() => () => {
            onCancel(false);
            getAdminDashboardResultsList();
          });
          setModalAutoCloseMs(1000);
          onMessageOpen();
        })
        .catch((err) => {
          console.error("Error sending data:", err);
          setModalMessage("Failed to send rollback request.");
          setModalType("alert");
          setModalCallback(null);
          onMessageOpen();
        });
      // });
      // onMessageOpen();
      // return;
    } else if (open_close === 0) {
      const payload = [];
      const payloadForResult = [];

      const open = inputValues.single.open?.trim();
      const close = inputValues.single.close?.trim();

      const hasOpen = open && /^\d{3}$/.test(open);
      const hasClose = close && /^\d{3}$/.test(close);

      const pattiMap = {
        singlePatti: 2,
        doublePatti: 3,
        triplePatti: 4,
      };

      let singleOpenDigit = getLastDigitSum(digit);
      let singleCloseDigit = getLastDigitSum(inputValues.singlePatti.close);
      // console.log(inputValues);

      payload.push({
        type_id: 1,
        mmid: inputValues.single.mmid,
        open_result: "",
        // open_result: hasOpen ? singleOpenDigit : "",
        close_result: hasClose ? singleCloseDigit : "",
      });
      payloadForResult.push({
        type_id: 1,
        mmid: inputValues.single.mmid,
        open_result: hasOpen ? singleOpenDigit : "",
        // close_result: hasClose ? singleCloseDigit : "",
      });

      // Always add type_id: 2-4 for Patti types (with available open/close)
      Object.entries(pattiMap).forEach(([pattiKey, typeId]) => {
        const mmid = inputValues[pattiKey]?.mmid;
        if (!mmid) return;

        payload.push({
          type_id: typeId,
          mmid,
          // open_result: hasOpen ? open : "",
          close_result: hasClose ? close : "",
        });
        payloadForResult.push({
          type_id: typeId,
          mmid,
          open_result: hasOpen ? open : "",
          // close_result: hasClose ? close : "",
        });
      });

      // Jodi (only when both open and close are present)
      if (hasOpen && hasClose) {
        const open = String(singleOpenDigit).padStart(1, "0");
        const close = String(singleCloseDigit).padStart(1, "0");

        payload.push({
          type_id: 5,
          // match_id: matchId,
          mmid: inputValues.jodi.mmid,
          open_result: "",
          // close_result: open + close,
        });
        payloadForResult.push({
          type_id: 5,
          // match_id: matchId,
          mmid: inputValues.jodi.mmid,
          open_result: open + close,
          close_result: open + close,
        });
      }

      if (inputValues.jodi.close !== "") {
        payload.push({
          type_id: 5,
          mmid: inputValues.jodi.mmid,
          open_result: "",
          close_result: "",
        });
      }

      if (payload.length === 0) {
        setModalMessage("Nothing to publish.");
        setModalType("alert");
        setModalCallback(null);
        onMessageOpen();
        return;
      }

      // setModalMessage("Are you sure you want to rollback this  result?");
      // setModalType("confirm");
      // setModalCallback(() => () => {
      const result = [];

      // payloadForResult.forEach(({ open_result, close_result, ...base }) => {
      //   if (open_result !== undefined && open_result !== "") {
      //     result.push({ ...base, open_result });
      //   }
      // });

      payloadForResult.forEach(
        ({ open_result, close_result, type_id, ...base }) => {
          if (open_result !== undefined && open_result !== "") {
            result.push({ ...base, type_id, open_result });
            if (
              type_id === 5 &&
              close_result !== undefined &&
              close_result !== ""
            ) {
              result.push({ ...base, type_id, close_result });
            }
          }
        }
      );

      const combinedData = Object.values(result);
      // console.log("Combined Data for Rollback:", combinedData);
      // return;

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

      const requestBody = {
        user_id: localStorage.getItem("uid"),
        result: combinedData,
        payload: payload,
      };

      const requestOptions = {
        method: "POST",
        headers,
        body: JSON.stringify(requestBody),
      };

      fetch(
        process.env.REACT_APP_API_HOST_OP + "/rollbackrequest",
        requestOptions
      )
        .then(() => {
          setModalMessage("Results rollbacked successfully!!!");
          setModalType("alert");
          setModalCallback(() => () => {
            onCancel(false);
            getAdminDashboardResultsList();
          });
          setModalAutoCloseMs(3000);
          onMessageOpen();
        })
        .catch((err) => {
          console.error("Error sending data:", err);
          setModalMessage("Failed to send rollback request.");
          setModalType("alert");
          setModalCallback(null);
          onMessageOpen();
        });
      // });

      // onMessageOpen();
      // return;
    }
  };

  // Update selectedDate when formData.matchDate changes
  useEffect(() => {
    if (formData?.matchDate) {
      setSelectedDate(convertDateToInputFormat(formData.matchDate, today));
    }
  }, [formData?.matchDate, today]);

  // Filter matches based on search value
  useEffect(() => {
    if (!matchSearchValue || matchSearchValue.trim() === "") {
      // Show all matches when search is empty
      setFilteredMatches(matches);
    } else {
      // Show all matches that match the search term (including selected match if it matches)
      const searchTerm = matchSearchValue.toLowerCase().trim();
      const filtered = matches.filter((match) =>
        match.name.toLowerCase().includes(searchTerm)
      );
      setFilteredMatches(filtered.length > 0 ? filtered : matches);
    }
  }, [matchSearchValue, matches]);

  useEffect(() => {
    if (resultDetails && Object.keys(resultDetails).length > 0) {
      // console.log("Result Details - ResultForm:", resultDetails);

      let open3Digit = null;
      let close3Digit = null;

      for (const item of Object.keys(resultDetails)) {
        // console.log("Item:", resultDetails[item]);
        if (
          !open3Digit &&
          typeof resultDetails[item].open_result === "string" &&
          resultDetails[item].open_result.length === 3
        ) {
          open3Digit = {
            result: resultDetails[item].open_result,
            type_id: resultDetails[item].type_id,
          };
        }

        if (
          !close3Digit &&
          typeof resultDetails[item].close_result === "string" &&
          resultDetails[item].close_result.length === 3
        ) {
          close3Digit = {
            result: resultDetails[item].close_result,
            type_id: resultDetails[item].type_id,
          };
        }

        if (open3Digit && close3Digit) break;
      }

      setInputValues({
        single: {
          mmid: resultDetails[1]?.mmid || "",
          // open: resultDetails[1]?.open_result || "",
          open: open3Digit?.result || "",
          openres: open3Digit?.result || "",
          // close: resultDetails[1]?.close_result || "",
          close: close3Digit?.result || "",
          closeres: close3Digit?.result || "",
        },
        singlePatti: {
          mmid: resultDetails[2]?.mmid || "",
          open: resultDetails[2]?.open_result || "",
          close: resultDetails[2]?.close_result || "",
        },
        doublePatti: {
          mmid: resultDetails[3]?.mmid || "",
          open: resultDetails[3]?.open_result || "",
          close: resultDetails[3]?.close_result || "",
        },
        triplePatti: {
          mmid: resultDetails[4]?.mmid || "",
          open: resultDetails[4]?.open_result || "",
          close: resultDetails[4]?.close_result || "",
        },
        jodi: {
          mmid: resultDetails[5]?.mmid || "",
          open: resultDetails[5]?.open_result || "",
          close: resultDetails[5]?.close_result || "",
        },
      });

      setSingleOpenDigit(getLastDigitSum(open3Digit?.result || "_"));
      setSingleCloseDigit(getLastDigitSum(close3Digit?.result || "_"));
      setJodiCloseDigit(singleOpenDigit + "" + singleCloseDigit);

      // Disable rows where result already exists
      // setDisabledRows({
      //   row1: resultDetails[1]?.open_result && resultDetails[1]?.close_result,
      //   row2: resultDetails[2]?.open_result && resultDetails[2]?.close_result,
      //   row3: resultDetails[3]?.open_result && resultDetails[3]?.close_result,
      //   row4: resultDetails[4]?.open_result && resultDetails[4]?.close_result,
      //   row5: resultDetails[5]?.open_result && resultDetails[5]?.close_result,
      // });

      // setSelectedRows({
      //   row1:
      //     (resultDetails[1]?.open_result && !resultDetails[1]?.close_result) ||
      //     (!resultDetails[1]?.open_result && resultDetails[1]?.close_result),
      //   row2:
      //     (resultDetails[2]?.open_result && !resultDetails[2]?.close_result) ||
      //     (!resultDetails[2]?.open_result && resultDetails[2]?.close_result),
      //   row3:
      //     (resultDetails[3]?.open_result && !resultDetails[3]?.close_result) ||
      //     (!resultDetails[3]?.open_result && resultDetails[3]?.close_result),
      //   row4:
      //     (resultDetails[4]?.open_result && !resultDetails[4]?.close_result) ||
      //     (!resultDetails[4]?.open_result && resultDetails[4]?.close_result),
      //   row5:
      //     (resultDetails[5]?.open_result && !resultDetails[5]?.close_result) ||
      //     (!resultDetails[5]?.open_result && resultDetails[5]?.close_result),
      // });
    }
  }, [resultDetails]);

  const formatMarketData = (rawData) => {
    const marketMap = {};
    rawData.forEach((item) => {
      const { market_id, marketname, matchname, match_id, draw_date } = item;
      if (!marketMap[market_id]) {
        marketMap[market_id] = {
          id: market_id,
          name: marketname,
          matches: [],
        };
      }
      marketMap[market_id].matches.push({
        id: match_id,
        name: matchname,
        draw_date: draw_date,
      });
    });
    return Object.values(marketMap);
  };

  const handleDateChange = async (e) => {
    const dateValue = e.target.value;
    setSelectedDate(dateValue); // Update the state
    setLoading(true);

    setMarketData([]);
    setSelectedMarketId("");
    setSelectedMatchName("");
    setMatches([]);
    setFilteredMatches([]);
    setMatchSearchValue("");
    setSingleOpenDigit("-");
    setSingleCloseDigit("-");
    setJodiCloseDigit("--");
    setOpenPattiType("");
    setClosePattiType("");

    setInputValues({
      single: { open: "", openres: "", close: "", closeres: "", mmid: -1 },
      singlePatti: { open: "", close: "", mmid: -1 },
      doublePatti: { open: "", close: "", mmid: -1 },
      triplePatti: { open: "", close: "", mmid: -1 },
      jodi: { open: "", close: "", mmid: -1 },
    });
    setSelectedRows({
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      row5: false,
      row11: false,
      row22: false,
    });
    setDisabledRows({
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      row5: false,
      row11: false,
      row22: false,
    });
    setResultDetails([]);

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_HOST}/getMarketById`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({ active_date: dateValue }),
        }
      );
      const data = await res.json();
      setMarketData(formatMarketData(data?.data));
    } catch (err) {
      console.error("❌ Error fetching markets:", err);
      setMarketData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMatchChange = (e) => {
    // console.log("Match changed:", e.target.value);
    setInputValues({
      single: { open: "", openres: "", close: "", closeres: "", mmid: -1 },
      singlePatti: { open: "", close: "", mmid: -1 },
      doublePatti: { open: "", close: "", mmid: -1 },
      triplePatti: { open: "", close: "", mmid: -1 },
      jodi: { open: "", close: "", mmid: -1 },
    });
    setSelectedRows({
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      row5: false,
      row11: false,
      row22: false,
    });
    setDisabledRows({
      row1: false,
      row2: false,
      row3: false,
      row4: false,
      row5: false,
      row11: false,
      row22: false,
    });
    setResultDetails([]);

    const matchId = e.target.value;

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

    const urlencoded = {
      user_id: localStorage.getItem("uid"),
      match_id: matchId,
    };

    let requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(urlencoded),
    };

    fetch(
      process.env.REACT_APP_API_HOST + "/getMatchTypeResults",
      requestOptions
    )
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          // console.log(result.data);

          const map = {};
          result.data.forEach((item) => {
            map[item.type_id] = item;
          });
          setResultDetails(map);
        }
      })
      .catch((err) => {
        console.log("Error fetching results:", err);
      })
      .finally(() => {});

    // alert(matchId)
    setSelectedMatchName(matchId);
    // console.log(matches);

    const selectedMatch = matches.find((m) => m.id === Number(matchId));
    // console.log(selectedMatch);
    if (selectedMatch) {
      setFormData({ mode: "Add", matchDate: selectedMatch.draw_date });
    } else {
      setFormData({ mode: "Add", matchDate: "" });
    }
  };

  const getLastDigitSum = (value) => {
    // console.log("Calculating last digit sum for:", value);
    if (value === "" || value === "_") return "_";
    const digits = value.toString().split("").map(Number);
    const sum = digits.reduce((acc, curr) => acc + curr, 0);
    const result = sum % 10;
    return result;
  };

  const checkPattiType = (number) => {
    const numStr = number.toString().padStart(3, "0");
    const counts = Object.values(
      [...numStr].reduce((acc, d) => ((acc[d] = (acc[d] || 0) + 1), acc), {})
    );
    if (counts.includes(3)) return "triplePatti";
    if (counts.includes(2)) return "doublePatti";
    if (counts.length === 3) return "singlePatti";
    return "Invalid Input";
  };
  const {
    isOpen: isMessageOpen,
    onOpen: onMessageOpen,
    onOpenChange: onMessageOpenChange,
    onClose: onMessageClose,
  } = useDisclosure();

  const {
    isOpen: isOpenOtp,
    onOpen: onOtpOpen,
    onOpenChange: onOtpOpenChange,
    onClose: onOtpClose,
  } = useDisclosure();

  const {
    isOpen: isPasswordOpen,
    onOpen: onPasswordOpen,
    onOpenChange: onPasswordOpenChange,
    onClose: onPasswordClose,
  } = useDisclosure();

  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("alert");
  const [modalCallback, setModalCallback] = useState(null);
  const [modalAutoCloseMs, setModalAutoCloseMs] = useState(0);

  useEffect(() => {
    if (isMessageOpen && modalType === "alert" && modalAutoCloseMs > 0) {
      const timeoutId = setTimeout(() => {
        if (typeof modalCallback === "function") {
          const maybeFn = modalCallback();
          if (typeof maybeFn === "function") {
            maybeFn();
          }
        }
        if (typeof onMessageClose === "function") {
          onMessageClose();
        }
        setModalAutoCloseMs(0);
      }, modalAutoCloseMs);
      return () => clearTimeout(timeoutId);
    }
  }, [
    isMessageOpen,
    modalType,
    modalAutoCloseMs,
    modalCallback,
    onMessageClose,
  ]);

  // if (loading) {
  //     return (
  //       <div className="absolute inset-0 flex items-center justify-center">
  //         <Spinner size="lg" variant="spinner" color="warning" />
  //       </div>
  //     );
  //   }

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      {showAlert && (
        <Alert
          color="success"
          className="mb-4"
          onClose={() => setShowAlert(false)}
        >
          {alertMessage}
        </Alert>
      )}
      {showErrorAlert && (
        <Alert
          color="danger"
          className="mb-4"
          onClose={() => setShowErrorAlert(false)}
        >
          {errorMessage}
        </Alert>
      )}
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {formData.id ? "Result" : "Add New Result"}
      </h3>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {/* Market */}
          {/* Draw Date */}

          <div>
            <label className="block text-sm font-medium text-gray-700 pb-1">
              Draw Date
            </label>
            <input
              type="date"
              name="draw_date"
              id="draw_date"
              className="w-full border border-gray-300 rounded-md p-2 bg-white/70 focus:outline-none focus:ring focus:ring-blue-200 focus:border-blue-500"
              value={selectedDate}
              max={today}
              onChange={handleDateChange}
              disabled={!!formData?.id}
            />
            {/* <Input
              type="text"
              name="draw_date"
              value={formData.matchDate}
              placeholder="Draw Date"
              className="border border-gray-300 rounded-xl"
              readOnly
            /> */}
          </div>
          {!formData.id ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Market
              </label>
              <Select
                className="max-w-md"
                placeholder="Select Market"
                selectedKeys={[selectedMarketId]}
                onChange={handleMarketChange}
              >
                {marketData.map((market) => (
                  <SelectItem key={market.id} value={market.id}>
                    {market.name}
                  </SelectItem>
                ))}
              </Select>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Market
              </label>
              <Input
                type="text"
                name="market_name"
                value={formData.marketname}
                placeholder="Market Name"
                className="border border-gray-300 rounded-xl"
                readOnly
              />
            </div>
          )}

          {/* Match */}
          {!formData.id ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Match
              </label>
              <Autocomplete
                className="max-w-md"
                placeholder="Search and select Match"
                selectedKey={
                  selectedMatchName ? String(selectedMatchName) : null
                }
                inputValue={matchSearchValue}
                onInputChange={(value) => {
                  // Always update the search value when user types
                  setMatchSearchValue(value);
                }}
                onOpenChange={(isOpen) => {
                  if (isOpen) {
                    // When dropdown opens, clear search value to show all matches
                    setMatchSearchValue("");
                  } else if (selectedMatchName) {
                    // When dropdown closes, restore selected match name if there's a selection
                    const selectedMatch = matches.find(
                      (m) => String(m.id) === String(selectedMatchName)
                    );
                    if (selectedMatch) {
                      setMatchSearchValue(selectedMatch.name);
                    }
                  }
                }}
                onSelectionChange={(key) => {
                  if (key !== null && key !== undefined) {
                    const matchId = String(key);
                    // Find the selected match from the full matches list
                    const selectedMatch = matches.find(
                      (m) => String(m.id) === matchId
                    );

                    // Update selectedMatchName
                    setSelectedMatchName(matchId);

                    const event = { target: { value: matchId } };
                    handleMatchChange(event);

                    // Set the search value to the selected match name for display
                    if (selectedMatch) {
                      setMatchSearchValue(selectedMatch.name);
                    }
                  } else {
                    // If selection is cleared, clear the search value too
                    setMatchSearchValue("");
                    setSelectedMatchName("");
                  }
                }}
                isDisabled={!matches.length}
                allowsCustomValue={false}
                items={filteredMatches}
                allowsEmptyCollection={false}
              >
                {(match) => (
                  <AutocompleteItem
                    key={String(match.id)}
                    value={String(match.id)}
                  >
                    {match.name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Match
              </label>
              <Input
                type="text"
                name="match_name"
                value={formData.matchname}
                placeholder="Match Name"
                className="border border-gray-300 rounded-xl"
                readOnly
              />
            </div>
          )}
        </div>

        {/* <div className="flex gap-8">
          <div className="flex gap-1 items-center">
            <div>
              <Checkbox
                isSelected={selectedRows.row1}
                onChange={(e) =>
                  handleRowCheckboxChange("row1", e.target.checked)
                }
                isDisabled={disabledRows.row1 || !inputValues.single.mmid}
                color="success"
              />
            </div>
            <div className="flex items-center gap-5">
              <div className="">Open : </div>
              <div>
                {" "}
                <Input type="number" value={inputValues.single.open} />
              </div>
            </div>
          </div>
          <div className="flex gap-0 items-center">
            <div>
              <Checkbox
                isSelected={selectedRows.row1}
                onChange={(e) =>
                  handleRowCheckboxChange("row1", e.target.checked)
                }
                isDisabled={disabledRows.row1 || !inputValues.single.mmid}
                color="success"
              />
            </div>
            <div className="flex items-center gap-6">
              <div className="">Close : </div>
              <div>
                {" "}
                <Input type="number" value={inputValues.single.open} />
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-8">
          <div className="flex gap-1 items-center">
            <div className="flex items-center gap-5">
              <div className="">Single : </div>
              <div>1</div>
            </div>
          </div>
          <div className="flex gap-0 items-center">
            <div className="flex items-center gap-6">
              <div className="">Close : </div>
              <div>5</div>
            </div>
          </div>
        </div>
        <div className="flex gap-8">
          <div className="flex gap-1 items-center">
            <div className="flex items-center gap-5">
              <div className="">Jodi : </div>
              <div>1</div>
            </div>
          </div>
        </div> */}

        {/* Black */}
        <div className="flex justify-center items-center py-6">
          <div className="border border-gray-300 rounded-2xl p-6 w-full max-w-xl bg-gray-100 to-white shadow-lg">
            {/* Input Row */}
            <div className="flex gap-4 justify-center flex-wrap sm:flex-nowrap mb-6">
              {/* Open Input */}
              <div className="flex items-start gap-1 bg-white p-3 rounded-xl w-full sm:w-fit border shadow-sm">
                {/* Checkbox */}
                <div>
                  <div className="flex items-center gap-1 mb-1">
                    <Checkbox
                      isSelected={selectedRows.row11}
                      onChange={(e) =>
                        handleRowCheckboxChange("row11", e.target.checked)
                      }
                      color="success"
                    />
                    <label className="text-sm text-gray-700 font-semibold whitespace-nowrap">
                      Open
                    </label>

                    <Input
                      type="number"
                      value={inputValues.single.openres}
                      onChange={(e) => {
                        if (selectedMatchName === "") {
                          setModalMessage("please choose Market / Match");
                          setModalType("alert");
                          setModalCallback(null);
                          onMessageOpen();
                          return;
                        }
                        const value = e.target.value;
                        // setOpenResultLength(value.length);
                        if (value.length === 3) {
                          // setSingleOpenDigit(getLastDigitSum(value));
                          // setOpenPattiType(checkPattiType(value));
                        } else if (value.length < 3) {
                          // setSingleOpenDigit("-");
                        }
                        if (
                          value === "" ||
                          (/^[0-9]+$/.test(value) && value.length <= 3)
                        ) {
                          setInputValues((prev) => ({
                            ...prev,
                            single: { ...prev.single, openres: e.target.value },
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      isDisabled={
                        !!resultDetails[1]?.open_result ||
                        !inputValues.single.mmid ||
                        !selectedRows.row11
                      }
                      placeholder="Enter open result"
                      size="sm"
                      variant="bordered"
                    />
                  </div>

                  <div className="flex items-center gap-1">
                    <Checkbox
                      isSelected={selectedRows.row1}
                      onChange={(e) =>
                        handleRowCheckboxChange("row1", e.target.checked)
                      }
                      color="success"
                    />
                    <label className="text-sm text-gray-700 font-semibold whitespace-nowrap">
                      Open
                    </label>

                    <Input
                      type="number"
                      value={inputValues.single.open}
                      onChange={(e) => {
                        if (selectedMatchName === "") {
                          setModalMessage("please choose Market / Match");
                          setModalType("alert");
                          setModalCallback(null);
                          onMessageOpen();
                          return;
                        }
                        const value = e.target.value;
                        setOpenResultLength(value.length);
                        if (value.length === 3) {
                          if (
                            inputValues.single.openres === "" ||
                            inputValues.single.openres.length < 3 ||
                            inputValues.single.openres.length > 3 ||
                            !/^[0-9]+$/.test(inputValues.single.openres) ||
                            inputValues.single.openres == null ||
                            inputValues.single.openres == undefined ||
                            inputValues.single.openres !== value
                          ) {
                            setModalMessage("Please confirm your open result");
                            setModalType("alert");
                            setModalCallback(null);
                            onMessageOpen();
                            return;
                          }
                          setSingleOpenDigit(getLastDigitSum(value));
                          setOpenPattiType(checkPattiType(value));
                        } else if (value.length < 3) {
                          setSingleOpenDigit("-");
                        }
                        if (
                          value === "" ||
                          (/^[0-9]+$/.test(value) && value.length <= 3)
                        ) {
                          setInputValues((prev) => ({
                            ...prev,
                            single: { ...prev.single, open: e.target.value },
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      isDisabled={
                        !!resultDetails[1]?.open_result ||
                        !inputValues.single.mmid ||
                        !selectedRows.row1
                      }
                      placeholder="Confirm open result"
                      size="sm"
                      variant="bordered"
                      className={`w-48 sm:w-full text-black ${
                        selectedRows.row1 &&
                        !resultDetails[1]?.open_result &&
                        !inputValues.single.open
                          ? "border-red-500"
                          : ""
                      }`}
                    />
                  </div>

                  {/* Bottom Message Row */}
                  <div className="flex justify-end">
                    <span className="text-xxs text-green-600 flex items-center gap-2">
                      {/* Result already published. */}
                      {openResultLength > 0 && openResultLength < 3 && (
                        <span className="text-xs text-red-500">
                          Maximum 3 digits
                        </span>
                      )}

                      {resultDetails[1]?.open_result &&
                        formData.mode !== "View" && (
                          <div className="mt-1">
                            <span className="text-xs text-green-600 flex items-center gap-2 mt-1">
                              Result already published&nbsp;
                              {/* <button
                                type="button"
                                className="underline text-blue-600 hover:text-blue-800 flex items-center"
                                onClick={() => {
                                  setRollbackData({
                                    gameIndex: 1,
                                    mmid: resultDetails[1]?.mmid,
                                    status: 0,
                                    result: resultDetails[1]?.open_result,
                                  });
                                  onOpen(); // this opens the modal
                                }}
                              >
                                <div className="flex gap-1">
                                  <span>Revert</span>
                                  <span className="pt-0.5">
                                    <RevertIcon />
                                  </span>
                                </div>
                              </button> */}
                            </span>
                          </div>
                        )}
                      {/* <button
                        type="button"
                        className="underline text-blue-600 hover:text-blue-800 flex items-center"
                      >
                        <span className="flex gap-1 items-center">
                          <span>Revert</span>
                          <span className="pt-0.5">
                            <RevertIcon />
                          </span>
                        </span>
                      </button> */}
                    </span>
                  </div>
                </div>
              </div>

              {/* Close Input */}
              <div className="flex items-start gap-1 bg-white p-4 rounded-xl w-full sm:w-fit border shadow-sm">
                {/* Checkbox */}
                <div>
                  <div className="flex items-center gap-1 mb-1">
                    <Checkbox
                      isSelected={selectedRows.row22}
                      onChange={(e) =>
                        handleRowCheckboxChange("row22", e.target.checked)
                      }
                      color="success"
                    />
                    <label className="text-sm text-gray-700 font-semibold whitespace-nowrap">
                      Close
                    </label>

                    <Input
                      type="number"
                      value={inputValues.single.closeres}
                      onChange={(e) => {
                        if (selectedMatchName === "") {
                          setModalMessage("please choose Market / Match");
                          setModalType("alert");
                          setModalCallback(null);
                          onMessageOpen();
                          return;
                        }
                        const value = e.target.value;
                        // setOpenResultLength(value.length);
                        if (value.length === 3) {
                          // setSingleOpenDigit(getLastDigitSum(value));
                          // setOpenPattiType(checkPattiType(value));
                        } else if (value.length < 3) {
                          // setSingleOpenDigit("-");
                        }
                        if (
                          value === "" ||
                          (/^[0-9]+$/.test(value) && value.length <= 3)
                        ) {
                          setInputValues((prev) => ({
                            ...prev,
                            single: {
                              ...prev.single,
                              closeres: e.target.value,
                            },
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      isDisabled={
                        !!resultDetails[1]?.close_result ||
                        !inputValues.single.mmid ||
                        !selectedRows.row22
                      }
                      placeholder="Enter close result"
                      size="sm"
                      variant="bordered"
                    />
                  </div>

                  <div className="flex items-center gap-1">
                    <Checkbox
                      isSelected={selectedRows.row2}
                      onChange={(e) =>
                        handleRowCheckboxChange("row2", e.target.checked)
                      }
                      color="success"
                    />
                    <label className="text-sm text-gray-700 font-semibold whitespace-nowrap">
                      Close
                    </label>
                    <Input
                      type="number"
                      value={inputValues.single.close}
                      onChange={(e) => {
                        if (selectedMatchName === "") {
                          // alert("please choose market/match");
                          // return;
                          setModalMessage("please choose Market / Match");
                          setModalType("alert");
                          setModalCallback(null); // no action, just OK
                          onMessageOpen();
                          return;
                        }
                        const value = e.target.value;
                        setCloseResultLength(value.length);
                        if (value.length === 3) {
                          if (
                            inputValues.single.closeres === "" ||
                            inputValues.single.closeres.length < 3 ||
                            inputValues.single.closeres.length > 3 ||
                            !/^[0-9]+$/.test(inputValues.single.closeres) ||
                            inputValues.single.closeres == null ||
                            inputValues.single.closeres == undefined ||
                            inputValues.single.closeres !== value
                          ) {
                            // setModalMessage("Please confirm your close result");
                            // setModalType("alert");
                            // setModalCallback(null);
                            // onMessageOpen();
                            // return;
                          }
                          setSingleCloseDigit(getLastDigitSum(value));
                          setClosePattiType(checkPattiType(value));
                        } else if (value.length < 3) {
                          setSingleCloseDigit("-");
                        }
                        if (
                          value === "" ||
                          (/^[0-9]+$/.test(value) && value.length <= 3)
                        ) {
                          setInputValues((prev) => ({
                            ...prev,
                            single: { ...prev.single, close: e.target.value },
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      isDisabled={
                        !!resultDetails[1]?.close_result ||
                        !inputValues.single.mmid ||
                        !selectedRows.row2
                      }
                      placeholder="Confirm close result"
                      size="sm"
                      variant="bordered"
                      className={`w-48 sm:w-full text-black ${
                        selectedRows.row1 &&
                        !resultDetails[1]?.close_result &&
                        !inputValues.single.close
                          ? "border-red-500"
                          : ""
                      }`}
                    />
                  </div>

                  {/* Bottom Message Row */}
                  <div className="flex justify-end mt-2">
                    <span className="text-xxs text-green-600 flex items-center gap-2">
                      {/* Result already published. */}
                      {closeResultLength > 0 && closeResultLength < 3 && (
                        <div>
                          <span className="text-xs text-red-500">
                            Maximum 3 digits
                          </span>
                        </div>
                      )}
                      {resultDetails[1]?.close_result &&
                        formData.mode !== "View" && (
                          <div>
                            <span className="text-xs text-green-600">
                              Result already published&nbsp;
                              {/* <button
                                type="button"
                                className="underline text-blue-600 hover:text-blue-800"
                                onClick={() => {
                                  setRollbackData({
                                    gameIndex: 1,
                                    mmid: resultDetails[1]?.mmid,
                                    status: 1,
                                    result: resultDetails[1]?.close_result,
                                  });
                                  onOpen();
                                }}
                              >
                                <div className="flex gap-1">
                                  <span>Revert</span>
                                  <span className="pt-0.5">
                                    <RevertIcon />
                                  </span>
                                </div>
                              </button> */}
                            </span>
                          </div>
                        )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Result Section */}
            <div className="flex flex-wrap items-center gap-10 justify-center">
              <div className="flex flex-col gap-6 sm:gap-2">
                {/* Single block */}
                <div
                  class="flex-1 bg-green-50 border border-green-200 rounded-lg p-4"
                  bis_skin_checked="1"
                >
                  <p class="text-center text-green-700 font-semibold mb-2">
                    Single
                  </p>
                  <div class="flex justaify-center gap-4" bis_skin_checked="1">
                    <div
                      class="w-12 h-12 rounded-full bg-white border border-green-300 shadow flex items-center justify-center"
                      bis_skin_checked="1"
                    >
                      <p class="text-lg font-bold text-green-800">
                        {singleOpenDigit}
                      </p>
                    </div>
                    <div
                      class="w-12 h-12 rounded-full bg-white border border-green-300 shadow flex items-center justify-center"
                      bis_skin_checked="1"
                    >
                      <p class="text-lg font-bold text-green-800">
                        {singleCloseDigit}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Jodi block */}
                <div className="flex flex-col items-center">
                  <label className="text-purple-700 font-semibold mb-2 text-lg">
                    Jodi
                  </label>
                  <div className="p-3 rounded-full w-[60px] h-[60px] bg-purple-100 border border-purple-400 shadow flex items-center justify-center">
                    <p className="text-xl font-bold text-purple-800">
                      {singleOpenDigit}
                      {singleCloseDigit}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* White */}

        {/* ) : ( */}
        {/* <Table aria-label="Results table">
            <TableHeader>
              <TableColumn>Match Type</TableColumn>
              <TableColumn>Open Result</TableColumn>
              <TableColumn>Close Result</TableColumn>
            </TableHeader>
            <TableBody emptyContent={"No results available"}>
              <TableRow key={1}>
                <TableCell>{formData.matchtype}</TableCell>
                <TableCell>{formData.open_result}</TableCell>
                <TableCell>{formData.close_result}</TableCell>
              </TableRow>
            </TableBody>
          </Table> */}
        {/* )} */}
        <div className="flex justify-end space-x-3">
          <Button color="danger" variant="light" onClick={onCancel}>
            Cancel
          </Button>
          {(formData.mode === "Add" || formData.mode === "Edit") && (
            <Button
              type="button"
              className="bg-admin_black text-white"
              onClick={() => handleSubmit()}
            >
              Publish
            </Button>
          )}
        </div>
      </form>
      <Modal
        isOpen={isOpen}
        placement="top-center"
        onOpenChange={onOpenChange}
        classNames={{
          backdrop: "bg-black/85", // darker overlay
        }}
      >
        <ModalContent>
          {(onClose) => (
            <form
              // onSubmit={(e) => {
              //   e.preventDefault(); // prevent page reload
              //   handleRollBack(
              //     rollbackData.gameIndex,
              //     rollbackData.mmid,
              //     rollbackData.status,
              //     rollbackData.result,
              //     rollbackReason,
              //     rollbackData.status === 0
              //       ? inputValues.singlePatti.open
              //       : inputValues.singlePatti.close
              //   );
              //   // console.log(inputValues);
              //   setRollbackReason("");
              //   onClose();
              // }}
              onSubmit={async (e) => {
                e.preventDefault();
                if (isSubmitting) return;

                setIsSubmitting(true);

                setPendingRollback({
                  gameIndex: rollbackData.gameIndex,
                  mmid: rollbackData.mmid,
                  status: rollbackData.status,
                  result: rollbackData.result,
                  reason: rollbackReason,
                  value:
                    rollbackData.status === 0
                      ? inputValues.singlePatti.open
                      : inputValues.singlePatti.close,
                });

                try {
                  await fetch(
                    process.env.REACT_APP_API_HOST + "/send/otp/for/rollback",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("jwt"),
                      },
                      body: JSON.stringify({
                        userId: localStorage.getItem("uid"),
                        userName: localStorage.getItem("name"),
                        mmid: rollbackData.mmid,
                      }),
                    }
                  );

                  setRollbackReason("");
                  onClose();
                  onOtpOpen();
                } catch (err) {
                  console.error("Failed to send OTP:", err);
                  alert("Failed to send OTP. Try again.");
                }
              }}
            >
              <ModalHeader className="flex flex-col gap-1">
                Rollback Reason
              </ModalHeader>
              <ModalBody>
                <Textarea
                  placeholder="Reason for Rollback"
                  variant="bordered"
                  required
                  value={rollbackReason}
                  isDisabled={isSubmitting}
                  onChange={(e) => setRollbackReason(e.target.value)}
                  className="w-full"
                />
              </ModalBody>
              <ModalFooter>
                <Button color="primary" type="submit">
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isMessageOpen}
        onOpenChange={onMessageOpenChange}
        classNames={{
          backdrop: "bg-black/35",
          wrapper:
            "flex items-center justify-center min-h-screen sm:-mt-10 md:-mt-8",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              {modalType === "confirm" && (
                <>
                  <ModalBody className="flex items-start justify-center min-h-[60px]">
                    <p className="text-center font-semibold">{modalMessage}</p>
                  </ModalBody>
                  <ModalFooter className="-mt-4">
                    <Button color="danger" variant="light" onPress={onClose}>
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onPress={() => {
                        if (typeof modalCallback === "function") {
                          const maybeFn = modalCallback();
                          if (typeof maybeFn === "function") {
                            maybeFn();
                          }
                        }
                        onClose();
                      }}
                    >
                      Yes
                    </Button>
                  </ModalFooter>
                </>
              )}

              {modalType === "alert" && (
                <>
                  <ModalBody className="flex items-center justify-center min-h-[80px]">
                    <p className="text-center font-semibold">{modalMessage}</p>
                  </ModalBody>
                </>
              )}
            </>
          )}
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpenOtp} onOpenChange={onOtpOpenChange}>
        <ModalContent>
          {(onClose) => (
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                if (!pendingRollback) return;

                try {
                  // verify OTP
                  const verifyRes = await fetch(
                    process.env.REACT_APP_API_HOST + "/verify/otp/for/rollback",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("jwt"),
                      },
                      body: JSON.stringify({
                        userId: localStorage.getItem("uid"),
                        otp: otpValue,
                      }),
                    }
                  );
                  const verifyData = await verifyRes.json();

                  console.log("OTP verify response:", verifyData);

                  if (!verifyData.success) {
                    setModalMessage("Invalid OTP / OTP expired");
                    setModalType("alert");
                    setModalCallback(null);
                    onMessageOpen();
                    return;
                  }

                  // finally call rollback with OTP
                  handleRollBack(
                    pendingRollback.gameIndex,
                    pendingRollback.mmid,
                    pendingRollback.status,
                    pendingRollback.result,
                    pendingRollback.reason,
                    pendingRollback.value,
                    otpValue
                  );

                  setOtpValue("");
                  setPendingRollback(null);
                  onClose();
                } catch (err) {
                  console.error("OTP verify failed:", err);
                  alert("OTP verification failed.");
                }
              }}
            >
              <ModalHeader>Enter OTP</ModalHeader>
              <ModalBody>
                <Input
                  placeholder="Enter OTP"
                  value={otpValue}
                  onChange={(e) => setOtpValue(e.target.value)}
                  required
                />
              </ModalBody>
              <ModalFooter>
                <Button onPress={onClose}>Cancel</Button>
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
      <PublishPreviewModal
        isOpen={isPreviewOpen}
        onOpenChange={onPreviewOpenChange}
        matchId={previewContext?.matchId}
        openDigit={previewContext?.openDigit}
        closeDigit={previewContext?.closeDigit}
        basePath={resolveBasePath()}
        onConfirm={() => {
          if (typeof modalCallback === "function") {
            const maybeFn = modalCallback();
            if (typeof maybeFn === "function") {
              maybeFn();
            }
          }
        }}
      />
      <Modal isOpen={isPasswordModalOpen} onOpenChange={setIsPasswordModalOpen}>
        <ModalContent>
          {(onClose) => (
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                await handleConfirmPublish(onClose);
              }}
            >
              <ModalHeader>Enter Password to Confirm</ModalHeader>
              <ModalBody>
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={passwordValue}
                  onChange={(e) => setPasswordValue(e.target.value)}
                  required
                  disabled={isPublishing}
                  endContent={
                    <button
                      type="button"
                      onClick={() => setShowPassword((v) => !v)}
                      className="focus:outline-none"
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? <EyeOff /> : <Eye />}
                    </button>
                  }
                />
              </ModalBody>
              <ModalFooter>
                <Button onPress={onClose} disabled={isPublishing}>
                  Cancel
                </Button>
                <Button color="primary" type="submit" isLoading={isPublishing}>
                  Submit
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ResultForm;
